import type { App, Plugin } from "@pimo/pimo-app-builder";

import type { TestAppState } from "../app";
import { NoAccessPage } from "../components/no-access-page";
import { APP_ROUTES } from "../constants";
import { HOME_PORTAL_LINK } from "../env";

export class NoAccessPlugin implements Plugin<TestAppState> {
  constructor(private readonly logout: () => void) {}

  onRegister(app: App<TestAppState>): void {
    const view = app.createView({ name: "NoAccess" });
    const page = view.addComponent({ component: NoAccessPage });
    page.mapState(({ language }) => ({ language }));

    page.on("no-access:home-portal", () => {
      window.location.assign(HOME_PORTAL_LINK);
    });
    // Keycloak still holds the refused session; signing in again without logging out returns here.
    page.on("no-access:logout", () => this.logout());

    app.createRoute({
      path: APP_ROUTES.noAccess,
      view,
      isOverlayChild: false,
    });
  }

  getName(): string {
    return "no-access-plugin";
  }
}
